<template>
  <div>
    <div class="head-box">
      <h4>{{ formName }}模板</h4>
      <div class="c-flex c-flex-item">
        <el-date-picker
          v-if="osg.has(path + ',searchDate')"
          v-model="searchDate"
          type="datetimerange"
          :picker-options="date.pickerOptions"
          start-placeholder="创建开始日期"
          end-placeholder="创建结束日期"
          :default-time="['00:00:00', '23:59:59']"
          value-format="yyyy-MM-dd HH:mm:ss"
          clearable
          @change="
            fpi.page = 1;
            getData();
          "
          class="search-date"
        ></el-date-picker>
        <el-input
          v-if="osg.has(path + ',searchValue')"
          placeholder="请输入要查询的内容"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
          class="c-m-l-10"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button
          v-if="osg.has(path + ',new')"
          type="primary"
          @click.native="doNew"
          class="c-m-l-10"
        >
          上传模板
        </el-button>
        <el-button
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport(
              {
                'is:state|integer#and': state == 'all' ? null : 1,
                'regex:name|string#and': searchValue,
                'gte:createTime|string#and': searchDate[0],
                'lte:createTime|string#and': searchDate[1],
                sortField: 'createTime',
                sortOrder: 'desc',
                beanName: 'printTemplate',
                title: '文档模板'
              },
              { dynamic: true, preset }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter" v-if="osg.has(path + ',filter')">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          :data="fpi.data"
          ref="table"
          style="width: 100%"
          height="calc(100% - 50px)"
          v-if="refresh"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
        >
          <c-table :fields="extFields"></c-table>
          <el-table-column
            fixed="right"
            width="100px"
            v-if="
              osg.has(path + ',edit') ||
                osg.has(path + ',remove') ||
                osg.has(path + ',exportDetail')
            "
          >
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-if="osg.has(path + ',edit')"
                    @click.native="doEdit(scope.row)"
                  >
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has(path + ',remove')"
                    @click.native="doRemove(scope.row)"
                  >
                    删除
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has(path + ',exportDetail')"
                    @click.native="
                      osg.doExport(
                        {
                          'is:state|integer#and': state == 'all' ? null : 1,
                          'regex:name|string#and': searchValue,
                          'gte:createTime|string#and': searchDate[0],
                          'lte:createTime|string#and': searchDate[1],
                          sortField: 'createTime',
                          sortOrder: 'desc',
                          beanName: colName,
                          title: scope.row.name || formName,
                          'fpi-_id': scope.row._id
                        },
                        { dynamic: true, preset, url: 'excel/exportOne.do' }
                      )
                    "
                  >
                    导出此条数据
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
        <el-dialog title="上传模板" :visible.sync="openDetail" :close-on-click-modal="false">
          <c-form
            :formData="formData"
            :fields="extFields"
            :options="options"
            ref="form"
            :upload="upload"
            labelWidth="160px"
            :area="area"
            @changeForm="osg.changeForm"
          ></c-form>
          <div slot="footer">
            <el-button type="primary" @click="doSave">确 定</el-button>
            <el-button @click="doInit">取 消</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
// import areajs from '../../resources/js/area.js';
export default {
  name: 'DocumentTemplates',
  inject: ['viewReload'], //注入nav里的viewReload方法
  data() {
    window.$this = this;
    return {
      name: '', //过滤器用
      refresh: true,
      path: '', //路径-读取角色权限
      colName: '',
      preset: '1',
      extId: null,
      formName: null,
      searchValue: '',
      searchDate: [],
      fpi: {
        page: 1,
        rows: 20
      },
      extFields: [],
      openDetail: false,
      options: {},
      formData: { exts: {} },
      state: '',
      rules: this.$util.rules,
      // 上传
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      //地址
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      }
    };
  },
  mounted() {
    this.path = decodeURIComponent(
      (window.location.pathname + window.location.search).substring(1)
    );
    this.name = this.osg.param('colName');
    this.colName = this.osg.param('colName');
    this.state = this.osg.param('state');
    this.doInit();
    // if (this.colName) this.getExtByColName();
    this.osg.getFields('printTemplate', () => {
      this.osg.getFpi();
      this.getData();
    });
  },
  methods: {
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = { exts: {} };
      if (this.$refs.formData) this.$refs.formData.resetFields();
    },
    // getExtByColName() {
    //   this.osg.ajax('biz/ext/queryByColName/' + this.colName + '.do', {}, res => {
    //     this.formName = res.entity.title;
    //     this.preset = res.entity.templateType == 'TT1' ? '1' : '0';
    //     this.extId = res.entity._id;
    //   });
    // },
    getData() {
      this.searchDate = this.searchDate || [];
      var params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'is:state|integer#and': this.state == 'all' ? null : 1,
        'regex:name|string#and': this.searchValue,
        'gte:createTime|string#and': this.searchDate[0],
        'lte:createTime|string#and': this.searchDate[1],
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      if (this.osg.has(this.path + ',filter')) {
        window.$that.getParams(params);
      }
      this.osg.setFpi(params);
      this.osg.ajax('printTemplate/query.do', params, res => {
        res.data = res.data.map(item => {
          item.exts = item.exts || {};
          return item;
        });
        // 渲染字段防止报错
        this.$util.renderExtFormFields(this.extFields, res.data);
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doEdit(row) {
      this.formData = row;
      this.openDetail = true;
    },
    doSave() {
      if (this.osg.validate()) {
        this.formData.state = 1; // 默认状态1
        let documents = this.formData.exts.documents;
        if (documents && documents[0] && documents[0].response) {
          this.formData.url = this.osg.downloadUrl + documents[0].response.key;
        }
        this.osg.ajax('printTemplate/upsert.do', { dataStr: JSON.stringify(this.formData) }, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    enable(row) {
      this.osg.ajax(
        'printTemplate/enable.do',
        {
          id: row._id
        },
        () => {
          this.getData();
          this.osg.toast('删除成功');
        }
      );
    },
    disable(row) {
      this.osg.ajax(
        'printTemplate/disable.do',
        {
          id: row._id
        },
        () => {
          this.getData();
          this.osg.toast('删除成功');
        }
      );
    },
    doRemove(row) {
      this.osg.confirm('是否确认删除？', () => {
        this.osg.ajax(
          'printTemplate/remove.do',
          {
            id: row._id
          },
          () => {
            this.getData();
            this.osg.toast('删除成功');
          }
        );
      });
    }
  },
  watch: {
    $route() {
      window.$this = this;
      this.viewReload();
    }
  }
};
</script>
